<template>
  <form-field :attribute="attribute" :type="type" :label="label" :required="required" :errorKeys="errorKeys">
    <input :type="type" :value="value" @input="update" />
  </form-field>
</template>

<script>
import ActsAsFormField from "../../mixins/ActsAsFormField";
import ActsAsTextInput from "../../mixins/ActsAsTextInput";

export default {
  mixins: [ActsAsFormField, ActsAsTextInput],

  props: {
    type: {
      type: String,
      required: false,
      default: () => "text",
    },
  },
};
</script>
